/**
 * 把服务端产出的文本文件落到本地下载目录。
 *
 * 只服务「内容已在服务端成型、客户端只负责存盘」的文本出口（数据备份快照）。
 * .xlsx 产物一律走下面的 downloadBytes——二进制过文本通道就毁了。
 */
export function downloadTextFile(filename: string, content: string, mime = 'text/plain'): void {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // 不撤销的话 Blob 会一直占内存到页面卸载
  URL.revokeObjectURL(url);
}

/**
 * 把已经在手上的一堆字节存盘（.xlsx 出口共用）。
 *
 * 撤销 URL 要留一拍：`click()` 触发的落盘是异步的，同一帧 revoke 在部分浏览器里会让下载悄悄取消。
 */
export function downloadBytes(filename: string, bytes: Uint8Array, mime: string): void {
  // TS 的 BlobPart 只认 ArrayBuffer 支撑的视图，而 Uint8Array 的泛型默认是 ArrayBufferLike；
  // 这里的两个来源（buildXlsx 现造的、resp.arrayBuffer() 包出来的）buffer 都是 ArrayBuffer，断言成立。
  const blob = new Blob([bytes as Uint8Array<ArrayBuffer>], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
